import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SellerSettingsOptions } from '../../../../enums/seller-settings/seller-settings-options';
import { useBinaryState } from '../../../../hooks/use-binary-state';
import { ConfigurationEditMode } from './configuration-edit-mode';
import { ConfigurationReadMode } from './configuration-read-mode';
import { useInventorySetup } from './use-inventory-setup';
import { messages } from './messages';

const inventoryShipNoStockItems = [
  {
    key: SellerSettingsOptions.allowShip.value,
    name: <FormattedMessage {...SellerSettingsOptions.allowShip.messageDescriptor} />,
  },
  {
    key: SellerSettingsOptions.warnShip.value,
    name: <FormattedMessage {...SellerSettingsOptions.warnShip.messageDescriptor} />,
  },
  {
    key: SellerSettingsOptions.errorShip.value,
    name: <FormattedMessage {...SellerSettingsOptions.errorShip.messageDescriptor} />,
  },
];

const inventoryTrackItems = {
  warn: <FormattedMessage {...messages.warnOfInventoryAdjustmentOption} />,
  doNotWarn: <FormattedMessage {...messages.doNotWarnOfInventoryAdjustmentOption} />,
};

export const ConfigurationSection = () => {
  const { onSave, onUpdate, onCancel, configuration, originalConfiguration } = useInventorySetup();

  const [isEditing, startEditing, stopEditing] = useBinaryState();

  return isEditing ? (
    <ConfigurationEditMode
      configuration={configuration}
      inventoryShipNoStockItems={inventoryShipNoStockItems}
      inventoryTrackItems={inventoryTrackItems}
      onCancel={onCancel}
      onSave={onSave}
      onUpdate={onUpdate}
      originalConfiguration={originalConfiguration}
      stopEditing={stopEditing}
    />
  ) : (
    <ConfigurationReadMode
      inventoryReOrderThreshold={configuration.inventoryReOrderThreshold}
      inventoryShipNoWarehouse={inventoryTrackItems[configuration.inventoryShipNoWarehouse]}
      inventoryShipUnknown={configuration.inventoryShipUnknown}
      inventoryTrackingEnabled={configuration.inventoryTrackingEnabled}
      noOnHandStockWarning={inventoryShipNoStockItems.find((item) => item.key === configuration.inventoryShipNoStock)?.name}
      startEditing={startEditing}
      unknownOnHandStockWarning={inventoryShipNoStockItems.find((item) => item.key === configuration.inventoryShipUnknown)?.name}
    />
  );
};
